import { render, staticRenderFns } from "./gerenZS.vue?vue&type=template&id=3ee82243&"
import script from "./gerenZS.vue?vue&type=script&lang=js&"
export * from "./gerenZS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports